import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import PageHero from "../components/global/PageHero";
import Flagship from "../components/services/Flagship";
// import ServiceCategories from "../components/services/ServiceCategories";
import ServiceDirectory from "../components/services/ServiceDirectory";

export default function Services() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Services" title="Everything you need to design, build and grow.">
                    One senior team across the whole stack — led by our flagship custom development practice.
                </PageHero>

                <Flagship />

                {/* <ServiceCategories /> */}

                <ServiceDirectory />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
